import { toast } from "sonner";

export const copyContact = async (c) => {
  const lines = [
    [c.name, c.title].filter(Boolean).join(" — "),
    c.company || "",
    c.phone_mobile ? `Mobile: ${c.phone_mobile}` : "",
    c.phone ? `Office: ${c.phone}` : "",
    c.email ? `Email: ${c.email}` : "",
  ].filter(Boolean);
  const text = lines.join("\n");
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    toast.success(`${c.name || "Contact"} copied to clipboard`);
  } catch {
    toast.error("Couldn't copy — your browser blocked clipboard access");
  }
};
